<template>
  <!-- -->
  <div class="defaultViewStyle">
    <list-page>
      <page-header>
        <template #default>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </page-header>
      <search-condition @search="resetSearch">
        <el-input v-model="searchInfo.searchKey" placeholder="商户名称"/>
      </search-condition>
      <table-list>
        <el-table stripe :data="dataList" height="100%">
          <el-table-column align="center" label="序号" width="60px" type="index"/>
          <el-table-column align="center" label="商户名称" prop="merchantName" min-width="120px"/>
          <el-table-column align="center" label="erp往来单位" prop="erpCustomerName" min-width="120px">
            <template v-slot="{row}">
              <el-text size="small" :type="row.erpCustomerName ? 'primary' : 'danger'">{{ row.erpCustomerName ? row.erpCustomerName : '未绑定' }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="操作" :align="'center'" width="150px">
            <template v-slot="{row}">
              <table-button el-type="primary" @click="toShowErpCustomer(row)">绑定</table-button>
<!--              <table-button type="delete" el-type="danger" message="是否确认删除此数据" @click="deleteData(row)">删除</table-button>-->
            </template>
          </el-table-column>
        </el-table>
      </table-list>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>

  <el-dialog v-model="showErpCustomer" width="40%" title="货位管理">
    <search-condition @search="queryErpCustomer" :show-search="true">
      <template #default>
        <el-input v-model="erpSearchInfo.searchKey" placeholder="请输入客户名称" @keydown.enter="queryErpCustomer" />
      </template>
    </search-condition>
    <dialog-table>
      <el-table stripe :data="erpCustomerList" height="100%">
        <el-table-column align="center" label="序号" width="60px" type="index"/>
        <el-table-column align="center" label="客户名称" prop="customerName"/>
        <el-table-column align="center" label="联系方式" prop="customerPhone"/>
        <el-table-column align="center" label="地址" prop="address"/>
        <el-table-column label="操作" :align="'center'">
          <template v-slot="{row}">
            <table-button type="delete" el-type="primary" @click="bindErpMerchant(row)">绑定</table-button>
          </template>
        </el-table-column>
      </el-table>
    </dialog-table>
    <form-page v-model:page-number="erpSearchInfo.pageNumber" v-model:page-size="erpSearchInfo.pageSize" :total-count="erpSearchInfo.totalCount" @onLoad="queryErpCustomer"/>
  </el-dialog>

</template>

<script>
import ProductStockComponent from "@/views/main/stock/stockManage/ProductStockComponent.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableList from "@/components/h5/layout/TableList";
import FormPage from "@/components/h5/layout/FormPage";
import SearchCondition from "@/components/h5/layout/SearchCondition";
import PageButton from "@/components/h5/button/PageButton";
import TableButton from "@/components/h5/button/TableButton";
import commonApi from "@/api/commonApi";
import stockApi from "@/api/main/stock/stockApi";
import Dictionary from "@/components/h5/Dictionary";
import PageHeader from "@/components/h5/layout/PageHeader";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import merchantErpRelationApi from "@/api/main/merchant/merchantErpRelationApi";
export default {
  name: "StockList",
  components: {
    TableButton,
    PageButton,
    SearchCondition, DialogTable,
    ListPage, TableList, FormPage, Dictionary, PageHeader, ProductStockComponent
  },
  data() {
    return {
      searchInfo: {},
      erpSearchInfo:{},
      dataList: [],
      bindData: {},
      erpCustomerList: [],
      showErpCustomer: false,
      customerSearchKey: "",
    };
  },
  created() {

  },
  methods: {
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    queryList() {
      merchantErpRelationApi.queryList(this.searchInfo).then(res => {
        this.searchInfo.totalCount = res.totalCount;
        this.dataList = res.records;
      })
    },
    toShowErpCustomer(row){
      this.queryErpCustomer().then(() => {
        this.bindData = row;
        this.showErpCustomer = true;
      })
    },
    queryErpCustomer(){
      return merchantErpRelationApi.queryErpMerchantList(this.erpSearchInfo).then(list => {
        this.erpCustomerList = list.records;
        this.erpSearchInfo.totalCount = list.totalCount;
      });
    },
    deleteData(row) {
      merchantErpRelationApi.deleteErpMerchant(row.id).then(() => this.queryList());
    },
    bindErpMerchant(row){
      merchantErpRelationApi.saveErpMerchant({
        merchantId: this.bindData.id,
        erpId: row.erpId,
        fullName: row.customerName
      }).then(() => {
        this.showErpCustomer = false;
        this.queryList();
      })
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tables";
</style>